import React from 'react';

export default function IntaofficeCreatedIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.4803 3.5C17.2647 3.5 17.0491 3.5825 16.8849 3.74671L15.2007 5.43092L14.0099 6.62171L4.5 16.1316V19.5H7.86842L20.2533 7.11513C20.5826 6.78587 20.5826 6.25276 20.2533 5.92434L18.0757 3.74671C17.9114 3.5825 17.6958 3.5 17.4803 3.5ZM17.4803 5.53289L18.4671 6.51974L17.3783 7.60855L16.3914 6.62171L17.4803 5.53289ZM15.2007 7.8125L16.1875 8.79934L7.17105 17.8158H6.18421V16.8289L15.2007 7.8125Z'
        fill='#7C00B1'
      />
    </svg>
  );
}
